export default "__VITE_ASSET__BsJziy$N__"